// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title[data-v-274ffaa3] {\n  font-size: 16px;\n  font-weight: bold;\n  color: #262626;\n}\n.desc[data-v-274ffaa3] {\n  font-size: 14px;\n  color: #595959;\n  margin: 10px 0px 20px 0px;\n  line-height: 1.5;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
